module.exports = __webpack_public_path__ + "a841b3214f657522b6b3c5d495eb4993.png";